import { render, staticRenderFns } from "./NewCreateBusiness.vue?vue&type=template&id=028851de&"
import script from "./NewCreateBusiness.vue?vue&type=script&lang=ts&"
export * from "./NewCreateBusiness.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports